/* eslint-disable for-direction */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import deleteIcon from '../../../assets/images/dashboard-business/deleteIcon.svg';
import {
  useGetAllStateWithSterlingBranchMutation,
  useGetStatesMutation,
} from '../../../features/businessRegistration/businessRegistrationSlice';
import { TStep3Branch, TStep3Info } from '../../../types';
import { decryptJson } from '../../../utils/decryptJson';
import { encryptData } from '../../../utils/encryptJson';
import { logUserOut } from '../../../utils/logUserOut';
import AddBranchForm from './AddBranchForm';
import BranchAddressFilledForm from './BranchAddressFilledForm';
// import AddBranchForm from './AddBranchForm';
import BusinessAddressFilledForm from './BusinessAddressFilledForm';
import BusinessAddressForm from './BusinessAddressForm';
import { getFromLocalStorage, setInLocalStorage } from '../../../utils/setRegInfoInLocalStorage';
import customToast, { ToastType } from '../../../components_/Toast';

type TProps = {
  step3Info: TStep3Info;
  setStep3Info: React.Dispatch<React.SetStateAction<TStep3Info>>;
  branches: TStep3Branch[];
  setStep3Branches: React.Dispatch<React.SetStateAction<TStep3Branch[]>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
};
const BusinessAddress = ({
  setStep,
  branches,
  setStep3Branches,
  setStep3Info,
  step3Info,
  step,
}: TProps) => {
  // const storedValues = localStorage.getItem('showAddBranchForm');
  const storedValues = getFromLocalStorage('showAddBranchForm');
  const [showAddBranchForm, setShowAddBranchForm] = useState(
    storedValues ? JSON.parse(storedValues) : false,
  );
  const [no, setNo] = useState(1);
  const [states, setStates] = useState<any[]>([]);
  const [statesApiError, setStatesApiError] = useState(false);
  const [nearestStatesApiError, setNearestStatesApiError] = useState(false);
  const [nearestSterlingStates, setNearestSterlingStates] = useState<any[]>([]);

  useEffect(() => {
    setInLocalStorage({ prop: 'showAddBranchForm', value: showAddBranchForm });
    // localStorage.setItem('showAddBranchForm', JSON.stringify(showAddBranchForm));
  }, [showAddBranchForm]);

  const noOfBranches = step3Info.noOfBranch;
  const branchesNo = noOfBranches === '3 or more' ? 1000 : Number(noOfBranches);

  const [getStates, { isLoading: lgaLoading }] = useGetStatesMutation();
  const [getSterlingBankStates, { isLoading: branchLoading }] =
    useGetAllStateWithSterlingBranchMutation();
  const [showingBranch, setShowingBranch] = useState(false);
  useEffect(() => {
    const handleGetStates = async () => {
      try {
        const body = encryptData({});
        const data = (await getStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setStates(res);
      } catch (err: any) {
        logUserOut(err?.status);
        setStatesApiError(true);
      }
    };
    handleGetStates();
  }, []);

  useEffect(() => {
    const handleGetSterlingBankStates = async () => {
      try {
        const body = encryptData({});
        const data = (await getSterlingBankStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setNearestSterlingStates(res);
      } catch (err: any) {
        logUserOut(err?.status);
        setNearestStatesApiError(true);
      }
    };
    handleGetSterlingBankStates();
  }, []);

  useEffect(() => {
    if (statesApiError) {
      customToast(
        'An error occured while getting the states, please refresh',
        ToastType.error,
        '',
        10000,
      );
    }
    if (nearestStatesApiError) {
      customToast(
        'An error occured while getting the nearest states a sterling bank branch is located in, please refresh',
        ToastType.error,
        '',
        10000,
      );
    }
  }, [nearestStatesApiError, statesApiError]);

  return (
    <div className='md:w-[700px] mx-auto'>
      {step3Info?.selectedLga ? (
        <BusinessAddressFilledForm
          info={step3Info}
          setInfo={setStep3Info}
          states={states}
          branches={branches}
          setBranches={setStep3Branches}
          nearestSterlingStates={nearestSterlingStates}
          setStep={setStep}
          showingBranch={showingBranch}
          lgaLoading={lgaLoading}
          branchLoading={branchLoading}
          setShowAddBranchForm={setShowAddBranchForm}
        />
      ) : (
        <BusinessAddressForm
          info={step3Info}
          setInfo={setStep3Info}
          setStep={setStep}
          states={states}
          setStates={setStates}
          nearestSterlingStates={nearestSterlingStates}
          setNearestSterlingStates={setNearestSterlingStates}
          setShowAddBranchForm={setShowAddBranchForm}
          lgaLoading={lgaLoading}
          branchLoading={branchLoading}
        />
      )}
      {branches.slice(0, branchesNo)?.map((branch, index) => (
        <React.Fragment key={branch?.streetName + branch?.streetNumber}>
          <React.Fragment>
            {/* <div className='border-b-[1px] my-[42px] border-[#CDD5D5] ml-[268px] mr-[106px] ' /> */}
            <div className='flex justify-between'>
              <div className='py-[40px] font-[500] md:text-[18px]'>{`Branch ${index + 1}`}</div>

              <div
                className='flex justify-end cursor-pointer items-center'
                onClick={() => {
                  const Branches = branches.filter(
                    (branch_) =>
                      branch_.streetName !== branch.streetName &&
                      branch_.streetNumber !== branch.streetNumber,
                  );
                  setStep3Branches(Branches);
                }}
              >
                <div className='flex justify-end cursor-pointer mr-[12px] '>
                  <img src={deleteIcon} alt={deleteIcon} className='h-[20px]' />
                </div>
                <span className='font-[500]'>Delete Branch</span>
              </div>
            </div>
          </React.Fragment>

          <BranchAddressFilledForm
            info={branch}
            index={index}
            setInfo={setStep3Branches}
            branches={branches}
            states={states}
            nearestSterlingStates={nearestSterlingStates}
            step3Info={step3Info}
            setStep={setStep}
            setShowingBranch={setShowingBranch}
            lgaLoading={lgaLoading}
            branchLoading={branchLoading}
          />
        </React.Fragment>
      ))}
      {showAddBranchForm && step3Info?.noOfBranch && branches.length < branchesNo ? (
        <AddBranchForm
          addBranch={setStep3Branches}
          setShowAddBranchForm={setShowAddBranchForm}
          setNo={setNo}
          no={no}
          states={states}
          nearestSterlingStates={nearestSterlingStates}
          setStep={setStep}
          step3Info={step3Info}
          branches={branches}
          setShowingBranch={setShowingBranch}
          lgaLoading={lgaLoading}
          branchLoading={branchLoading}
        />
      ) : null}
    </div>
  );
};

export default BusinessAddress;
